import { combineReducers } from "@reduxjs/toolkit";
import Food from "./FoodReducer";
import Xook from "./XookReducer";
import Dish from "./DishReducer";
import Cart from "./CartReducer";
import User from "./UserReducer";
import Inventory from "./InventoryReducer";

const rootReducer = combineReducers({
    Food,
    Xook,
    User,
    Dish,
    Cart,
    Inventory
});

export default rootReducer;